var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "select-head el-card p-16 mt-24" },
      [
        _c("MyTitle", [_vm._v("产业链简介")]),
        _vm.chainDesc
          ? _c("div", { staticClass: "fx mt-8" }, [
              _vm._v(" " + _vm._s(_vm.chainDesc) + " "),
            ])
          : _c("EmptyBox", { staticClass: "chain-desc" }),
      ],
      1
    ),
    _c("div", { staticClass: "fx mt-24" }, [
      _c(
        "div",
        { staticClass: "mid-card el-card p-16" },
        [
          _c("MyTitle", { staticClass: "mb-16" }, [
            _vm._v(" 产业政策 "),
            _c(
              "div",
              {
                attrs: { slot: "right" },
                on: {
                  click: function ($event) {
                    return _vm.goPageClick("policy")
                  },
                },
                slot: "right",
              },
              [_vm._v("查看更多")]
            ),
          ]),
          !_vm.policyList.length
            ? _c("EmptyBox")
            : _vm._l(_vm.policyList, function (item, i) {
                return _c("TextDocument", { key: i, attrs: { data: item } })
              }),
        ],
        2
      ),
      _c(
        "div",
        { staticClass: "mid-card el-card p-16 ml-24" },
        [
          _c("MyTitle", { staticClass: "mb-16" }, [
            _vm._v("产业新闻 "),
            _c(
              "div",
              {
                attrs: { slot: "right" },
                on: {
                  click: function ($event) {
                    return _vm.goPageClick("news")
                  },
                },
                slot: "right",
              },
              [_vm._v("查看更多")]
            ),
          ]),
          !_vm.newsList.length
            ? _c("EmptyBox")
            : _vm._l(_vm.newsList, function (item, i) {
                return _c("TextDocument", {
                  key: i,
                  attrs: { data: item, news: "" },
                })
              }),
        ],
        2
      ),
    ]),
    _c(
      "div",
      { staticClass: "el-card mt-24 p-16" },
      [
        _c("MyTitle", { staticClass: "mb-16" }, [
          _vm._v(" 产业链图谱 "),
          _c(
            "div",
            {
              attrs: { slot: "right" },
              on: {
                click: function ($event) {
                  return _vm.goPageClick("map")
                },
              },
              slot: "right",
            },
            [_vm._v("查看完整产业链")]
          ),
        ]),
        _c(
          "div",
          [
            !_vm.hasStream ? _c("EmptyBox") : _vm._e(),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.hasStream,
                    expression: "hasStream",
                  },
                ],
                staticClass: "stream-header mt-16",
              },
              [
                _c("div", [_vm._v("上游")]),
                _c("div", [_vm._v("中游")]),
                _c("div", [_vm._v("下游")]),
              ]
            ),
            _c("div", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.hasStream,
                  expression: "hasStream",
                },
              ],
              ref: "container",
            }),
          ],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "el-card mt-24 p-16" },
      [
        _c("MyTitle", { staticClass: "mb-16" }, [
          _vm._v(" 头部企业 "),
          _c(
            "div",
            {
              attrs: { slot: "right" },
              on: {
                click: function ($event) {
                  return _vm.goPageClick("distribution")
                },
              },
              slot: "right",
            },
            [_vm._v("查看更多企业分布")]
          ),
        ]),
        _vm.classifyOptions.length
          ? _c(
              "div",
              { staticClass: "fx-wrap" },
              _vm._l(_vm.classifyOptions, function (item, i) {
                return _c("CompanyClassify", { key: i, attrs: { data: item } })
              }),
              1
            )
          : _c("EmptyBox", { staticClass: "chain-desc" }),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "el-card mt-24 p-16" },
      [
        _c("MyTitle", { staticClass: "mb-16" }, [
          _vm._v(" 产业发展趋势 "),
          _c(
            "div",
            {
              attrs: { slot: "right" },
              on: {
                click: function ($event) {
                  return _vm.goPageClick("analyze")
                },
              },
              slot: "right",
            },
            [_vm._v("查看更多产业分析")]
          ),
        ]),
        _c(
          "div",
          { staticClass: "fx-wrap" },
          [
            _c("div", { staticClass: "title pt-1" }, [
              _vm._v("二级市场·上市公司业务发展趋势"),
            ]),
            _c("MyEcharts", { ref: "chartFirst4", staticClass: "w50 h300" }),
            _c("MyEcharts", { ref: "chartFirst5", staticClass: "w50 h300" }),
            _c("div", { staticClass: "title" }, [
              _vm._v("一级市场·投融资趋势"),
            ]),
            _c("MyEcharts", { ref: "chartFirst6", staticClass: "w50 h300" }),
            _c("MyEcharts", { ref: "chartFirst7", staticClass: "w50 h300" }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }